import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "model": _vm.form,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    staticClass: "fold"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "label": "公文名称",
      "prop": "fileName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入公文名称"
    },
    model: {
      value: _vm.form.fileName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fileName", $$v);
      },
      expression: "form.fileName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "label": "拟稿日期",
      "prop": "createTime"
    }
  }, [_c('a-range-picker', {
    attrs: {
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.form.createTime,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "createTime", $$v);
      },
      expression: "form.createTime"
    }
  })], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.searchFrom.resetFields();
      }
    }
  }, [_vm._v("重置")])], 1)])], 1), _c('a-card', {
    attrs: {
      "size": "small",
      "title": "收文列表",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "table-card-view",
    attrs: {
      "size": "middle",
      "row-key": function rowKey(row, index) {
        return row.docId + "".concat(index);
      },
      "dataSource": _vm.tableData,
      "columns": _vm.columns,
      "pagination": _vm.paginationTable,
      "bordered": "",
      "scroll": {
        y: 550
      }
    },
    scopedSlots: _vm._u([{
      key: "sendUser",
      fn: function fn(text, record) {
        return [_c('span', [_vm._v(" " + _vm._s(record.sendUser + '(' + record.sendOrganName + '/' + record.sendPostName + ')') + " ")])];
      }
    }, {
      key: "isIssue",
      fn: function fn(text, record) {
        return [record.isIssue === 1 ? _c('span', [_vm._v("允许")]) : _vm._e(), record.isIssue === 0 ? _c('span', [_vm._v("不允许")]) : _vm._e()];
      }
    }, {
      key: "isPoint",
      fn: function fn(text, record) {
        return [record.isPoint === 1 ? _c('span', [_vm._v("是")]) : _vm._e(), record.isPoint === 0 ? _c('span', [_vm._v("否")]) : _vm._e()];
      }
    }, {
      key: "isMajor",
      fn: function fn(text, record) {
        return [record.isMajor === 1 ? _c('span', [_vm._v("主送")]) : _vm._e(), record.isMajor === 0 ? _c('span', [_vm._v("抄送")]) : _vm._e(), record.isMajor !== 0 && record.isMajor !== 1 ? _c('span', [_vm._v("分发")]) : _vm._e()];
      }
    }, {
      key: "operation",
      fn: function fn(text, record) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', {
          key: "1"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewProcessClick(record);
            }
          }
        }, [_vm._v(" 查看 ")])], 1), record.isIssue === 1 ? _c('a-menu-item', {
          key: "2"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.distribute(record);
            }
          }
        }, [_vm._v("分发")])], 1) : _vm._e(), record.isIssue === 1 ? _c('a-menu-item', {
          key: "3"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewReadStatus(record);
            }
          }
        }, [_vm._v(" 分发查阅情况 ")])], 1) : _vm._e()], 1)], 1)];
      }
    }])
  })], 1), _c('a-modal', {
    attrs: {
      "visible": _vm.personPickShow,
      "centered": true,
      "title": "分发",
      "maskClosable": false,
      "ok-text": "确认",
      "cancel-text": "取消"
    },
    on: {
      "cancel": _vm.handleCancel,
      "ok": _vm.submitSend
    }
  }, [_c('a-form-model', {
    ref: "sendForm",
    attrs: {
      "model": _vm.sendForm,
      "rules": _vm.rules
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否继续分发",
      "prop": "isIssue",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      }
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.sendForm.isIssue,
      callback: function callback($$v) {
        _vm.$set(_vm.sendForm, "isIssue", $$v);
      },
      expression: "sendForm.isIssue"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")]), _c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")])], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      }
    }
  }, [_c('a-cascader', {
    ref: "currOrganCascader",
    style: {
      width: '100%'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.form.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "organPostId", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.organPostId"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "分发",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 12
      },
      "prop": "result"
    }
  }, [_c('select-person', {
    ref: "personPick",
    attrs: {
      "businessId": 1,
      "width": "100%",
      "height": "9.375rem"
    },
    model: {
      value: _vm.sendForm.result,
      callback: function callback($$v) {
        _vm.$set(_vm.sendForm, "result", $$v);
      },
      expression: "sendForm.result"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };